import { Decimal } from 'decimal.js';
import { roundToCents } from '../accounts-receivable/round-to-cents.js';
/** MyTrace's per-category credit owed (CreditAuditDialog.vue calculateCreditOwed), rounded to whole cents. */
export function computePromotionCreditLineAmount(input) {
    const quantity = new Decimal(input.quantity);
    const share = new Decimal(input.percentageOff).dividedBy(100);
    const wholesaleCost = quantity.times(input.unitPrice);
    const costAfterCredit = wholesaleCost.times(new Decimal(1).minus(share));
    const customerPaidShare = new Decimal(input.customerPaid).times(quantity).times(share);
    return roundToCents(wholesaleCost.minus(costAfterCredit).minus(customerPaidShare));
}
//# sourceMappingURL=compute-promotion-credit-line-amount.js.map